import { NgModule } from '@angular/core';
// Required services for navigation
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ForgotPasswordComponent } from './components/onboarding/forgot-password/forgot-password.component';
import { SignInComponent } from './components/onboarding/sign-in/sign-in.component';
import { VerifyEmailComponent } from './components/onboarding/verify-email/verify-email.component';
import { AuthGuard } from './shared/guard/auth.guard';
import { SignUpComponent } from './components/onboarding/sign-up/sign-up.component';
import { EventsComponent } from './common/events/events.component';
import { AdminAccountComponent } from './common/admin-account/admin-account.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { CalendarComponent } from './components/calendar/calendar.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { LinkTreeComponent } from './components/link-tree/link-tree.component';
import { CheckSafacoinsCodeComponent } from './components/check-safacoins-code/check-safacoins-code.component';

// Import all the components for which navigation service has to be activated 

const routes: Routes = [
  { path: '', redirectTo: '/events', pathMatch: 'full'},
  { path: 'sign-in', component: SignInComponent},
  { path: 'register-user', component: SignUpComponent},
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'verify-email-address', component: VerifyEmailComponent },
  { path: 'link-tree', component: LinkTreeComponent },
  { path: 'check-codes', component: CheckSafacoinsCodeComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-and-conditions', component:  TermsAndConditionsComponent},
  { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
  { path: 'events', component: EventsComponent, canActivate: [AuthGuard] },
  { 
    path: 'gifts', 
  loadChildren:()=> import('./components/delete-gift/delete-gift.module').then(m=> m.DeleteGiftModule)},
  { path: 'calendar', component: CalendarComponent, canActivate: [AuthGuard] },
  { path: 'account', component: AdminAccountComponent, canActivate: [AuthGuard] },
  { path: '**', redirectTo: '/' }
];


@NgModule({
  
  imports: [RouterModule.forRoot(routes, {
    preloadingStrategy: PreloadAllModules,
    scrollPositionRestoration: 'top'
  })],
  exports: [RouterModule]
})

export class AppRoutingModule { }